module.exports = __webpack_public_path__ + "img/h-sdb.3606f3c0.png";